// extracted by mini-css-extract-plugin
export default {"postStats":"PostInfo_postStats__a6Ih5","liked":"PostInfo_liked__CugeK","likeContainer":"PostInfo_likeContainer__8WKfR"};